import React from 'react'
import { Link } from 'react-router-dom'
import { reportConversion } from '../../Helper';

const SocialMedia = () => {  
  const handleClickInsta = () => {
    // Push GTM event
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "ctaButtonClick",
      buttonName: "Go To Instagram",
      page: window.location.pathname
    });

  };
  const handleClickWA_old = () => {
        // Push GTM event    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "ctaButtonClick",
      buttonName: "Go To WhatsApp",
      page: window.location.pathname
    });
    // Redirect to third-party link
    //window.open("https://ig.me/m/chaashni.dubai", "_blank", "noopener,noreferrer");
  };
  const handleClickWA = (e) => {
    e.preventDefault();    
    const whatsappUrl = `https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}`;
   
    reportConversion(whatsappUrl);
  };
  return (    
    <div className="social-btns">
        <Link rel="noopener noreferrer" onClick={handleClickWA}><img src='images/social-icon/whatsapp.png' alt='connect us on Whatsapp' /></Link>
        <Link target="_blank" to="https://ig.me/m/chaashni.dubai" rel="noopener noreferrer" onClick={handleClickInsta}><img src='images/social-icon/instagram.png' alt='connect us on Instagram' /></Link>
    </div>
  )
}

export default SocialMedia
